const LOGOUT_MARKER_KEY = 'gccStudio.explicitLogout';
export const LOGOUT_STATE_EVENT = 'gccStudio:logoutStateChanged';
export const SESSION_ACTIVITY_KEY = 'gccStudio.lastActivity';

// Generated by GitHub Copilot - Oct-24-2026
/**
 * Checks whether this browser has an explicit logout marker.
 * Storage failures are handled independently so sessionStorage can still
 * protect the current tab when localStorage is unavailable.
 */
export function isExplicitlySignedOut() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.localStorage.getItem(LOGOUT_MARKER_KEY)) return true;
  } catch { /* Continue with the tab-scoped fallback. */ }
  try {
    return Boolean(window.sessionStorage.getItem(LOGOUT_MARKER_KEY));
  } catch { /* Storage is unavailable in this browser context. */ }
  return false;
}

/**
 * Persists an explicit logout across tabs and notifies the current tab.
 */
export function markExplicitlySignedOut() {
  if (typeof window === 'undefined') return;
  const marker = String(Date.now());
  try {
    window.localStorage.setItem(LOGOUT_MARKER_KEY, marker);
  } catch { /* sessionStorage still protects this tab. */ }
  try {
    window.sessionStorage.setItem(LOGOUT_MARKER_KEY, marker);
  } catch { /* The Microsoft redirect remains the sign-out mechanism. */ }
  window.dispatchEvent(new Event(LOGOUT_STATE_EVENT));
}

/**
 * Removes the logout marker after Microsoft confirms a successful sign-in.
 */
export function clearExplicitSignOut() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(LOGOUT_MARKER_KEY);
  } catch { /* Continue with the tab-scoped marker. */ }
  try {
    window.sessionStorage.removeItem(LOGOUT_MARKER_KEY);
  } catch { /* The localStorage event may still update other tabs. */ }
  window.dispatchEvent(new Event(LOGOUT_STATE_EVENT));
}

/** Resets the shared inactivity clock after a successful authentication redirect. */
export function resetSessionActivity() {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(SESSION_ACTIVITY_KEY, String(Date.now()));
  } catch { /* The session watcher falls back to a tab-local timer. */ }
}